const piedata = [
  {
    "id": "php",
    "label": "php",
    "value": 58,
    "color": "hsl(312, 70%, 50%)"
  },
  {
    "id": "stylus",
    "label": "stylus",
    "value": 29,
    "color": "hsl(342, 70%, 50%)"
  },
  {
    "id": "ruby",
    "label": "ruby",
    "value": 26,
    "color": "hsl(322, 70%, 50%)"
  },
  {
    "id": "java",
    "label": "java",
    "value": 359,
    "color": "hsl(261, 70%, 50%)"
  },
  {
    "id": "go",
    "label": "go",
    "value": 305,
    "color": "hsl(337, 70%, 50%)"
  }
];

export default piedata;



// WEBPACK FOOTER //
// ./src/assets/data/samplepiedata.ts